export default __webpack_public_path__ + "assets/images/4a9fa8e26821fefb41d695148a131b57.webp";